interface IConfig {
  tokenKey: string;
  verifierKey: string;
  solutionKey: string;
}
export class AuthService {
  private config: IConfig;

  constructor(config: IConfig) {
    this.config = config;
  }

  // Store token in localStorage, hello XSS world.
  saveToken(token: any) {
    localStorage.setItem(this.config.tokenKey, JSON.stringify(token));
    // Clean up any stale verifier left by the legacy PKCE flow.
    localStorage.removeItem(this.config.verifierKey);
  }

  loadToken() {
    return JSON.parse(localStorage.getItem(this.config.tokenKey) || 'null');
  }

  clearToken() {
    localStorage.removeItem(this.config.verifierKey);
    localStorage.removeItem(this.config.tokenKey);
  }

  saveSolution(sid: string) {
    try {
      sessionStorage.setItem(this.config.solutionKey, sid);
      localStorage.setItem(this.config.solutionKey, sid);
    } catch {
      // Empty
    }
  }

  loadSolution() {
    return (
      sessionStorage.getItem(this.config.solutionKey) ||
      localStorage.getItem(this.config.solutionKey)
    );
  }

  clearSolution() {
    return sessionStorage.removeItem(this.config.solutionKey);
  }
}

export const authService = new AuthService({
  tokenKey: '__t',
  verifierKey: '__v',
  solutionKey: '__s',
});
